import { render, staticRenderFns } from "./GeoForm.vue?vue&type=template&id=2a28d49d&"
import script from "./GeoForm.vue?vue&type=script&lang=ts&"
export * from "./GeoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports